import OnlineRentalDetails from '../../../../../pages/vip/features/online-rental-details/online-rental-details.desktop';

export default OnlineRentalDetails;
